import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '../../../apis/baseQuery';
import { API_CONSTANTS } from '../../../utils/constants';
import { ApiResponse } from '../../../model';

import type { SystemNotificationDetail } from './model';

export const systemNotificationsApi = createApi({
  reducerPath: 'systemNotificationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SystemNotification'],
  endpoints: (build) => ({
    getSystemNotificationDetail: build.query<
      ApiResponse<SystemNotificationDetail>,
      string
    >({
      query: (templateId) => ({
        url: API_CONSTANTS.SYSTEM_NOTIFICATIONS.DETAIL_URL(templateId),
        method: 'GET',
      }),
      providesTags: (_result, _error, templateId) => [
        { type: 'SystemNotification', id: templateId },
      ],
    }),
    editSystemNotification: build.mutation<
      ApiResponse<Record<string, never>>,
      { id: string; systemNotificationContent?: string; status?: string }
    >({
      query: (body) => ({
        url: API_CONSTANTS.SYSTEM_NOTIFICATIONS.EDIT_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'SystemNotification', id },
        { type: 'SystemNotification', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useLazyGetSystemNotificationDetailQuery,
  useEditSystemNotificationMutation,
} = systemNotificationsApi;

export default systemNotificationsApi;
